<template>
  <button class="hvr-grow" :class="buttonStyle" :aria-label="aria" :style="styleObject">{{content}}</button>
</template>

<script>
export default {
  props: {
    primary: {
      type: Boolean,
      required: false
    },
    secondary: {
      type: Boolean,
      required: false
    },
    content: {
      type: String,
      required: true
    },
    aria: {
      type: String,
      required: false
    },
    botSize: {
      type: Number,
      required: false,
    }
  },
  data() {
    return {
      buttonStyle: this.secondary ? "custom-secondary" : "custom-primary",
      styleObject: {
        maxWidth: this.botSize + "px",
        width: this.botSize ? "100%" : "auto"
      }
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";

button {
  cursor: pointer;
  font-family: Helveticalstd;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 3px;
  min-width: 200px;
  word-break: break-word;
  margin: 10px auto;
}
.application.theme--light {
  &.dark {
    .custom-primary {
      background-color: $secondary-red;
      color: $white;
    }

    .custom-secondary {
      background-color: $black-dav;
      color: $white;
      border: 2px solid $white;
    }
  }
  &.light {
    .custom-primary {
      background-color: $primary-red;
      color: $white;
    }

    .custom-secondary {
      background-color: $white;
      color: $primary-red;
      border: 2px solid $primary-red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Button.vue?0440fae0